import { useController } from 'react-hook-form';
import { InputGroup, PasswordInput as RSuitePasswordInput } from 'rsuite';
import { icons } from '@shared/static/icons';
import { FormGroup } from '@shared/ui/forms/display';
import { passwordRule } from '@utils/validation';

export default function PasswordInput({
  control,
  name,
  label,
  error,
  validation,
  placeholder,
  noValidation,
  onValueChange,
}) {
  const { field } = useController({
    control,
    name,
    rules: {
      required: true,
      validate: noValidation ? undefined : (validation ?? passwordRule),
    },
  });

  return (
    <FormGroup error={error} label={label}>
      <InputGroup inside className={field.value ? 'has-value' : ''}>
        <RSuitePasswordInput
          placeholder={placeholder}
          startIcon={icons.password}
          renderVisibilityIcon={(visible) =>
            visible ? icons['visible-off'] : icons.visible
          }
          value={field.value ?? ''}
          onChange={(value) => {
            field.onChange(value);
            onValueChange?.(value);
          }}
        />
      </InputGroup>
    </FormGroup>
  );
}
